/**
 * Whether a nav link's section holds the current page, so the link can be marked as the page's
 * section (`aria-current="page"` and its active style). A section holds every page beneath its
 * path, which is why an expert's page at `/directory/inquiry/12` keeps Directory current. Route
 * groups such as `(open)` never appear in the address bar, so they are dropped from the link
 * before comparing.
 */
export function isCurrentSection(pathname: string, href: string | undefined): boolean {
  if (!href) {
    return false;
  }

  const section = href.replace(/\/\([^/)]+\)/g, '').replace(/\/+$/, '');

  if (!section) {
    return false;
  }

  return pathname === section || pathname.startsWith(`${section}/`);
}
